export default __webpack_public_path__ + "static/media/shop-america.184e2d6a.png";